'use strict';

export default class AccountCommonController {
	/*@ngInject*/
	constructor($http, $scope) 
	{
		//console.log("::AccountCommonController");
		this.user = {};

		$scope.vm.OnCountrySelect = function(item, model)
		{
			if (!item || !item.iso2) return;

			$scope.vm.user.region1 = null;
			$scope.vm.user.region2 = null;

			$http.post("/api/geonames/regions1/" + item.iso2)
			.then(response => {
				$scope.vm.regions1 = response.data;
			});
		}

		$scope.vm.CountryClear = function(item, model)
		{
			$scope.vm.user.country = null;
			$scope.vm.regions1 = null;
			$scope.vm.user.region1 = null;
			$scope.vm.regions2 = null;
			$scope.vm.user.region2 = null;
		}

		$scope.vm.OnRegion1Select = function(item, model)
		{
			if (!item || !item.id) return;

			$scope.vm.user.region2 = null;

			$http.post("/api/geonames/regions2/" + item.id)
			.then(response => {
				$scope.vm.regions2 = response.data;
			});
		}

		$scope.vm.Region1Clear = function(item, model)
		{
			$scope.vm.user.region1 = null;
			$scope.vm.regions2 = null;
			$scope.vm.user.region2 = null;
		}

		$scope.$watch('form.$valid', function(valid, oldvalue)
		{
			if (valid === true)
				$scope.vm.showError = false;
		});

		$scope.vm.Region2Clear = function(item, model)
		{
			$scope.vm.user.region2 = null;
		}
	}
}



// WEBPACK FOOTER //
// ./client/app/account/account/account_common.controller.js